<template>
  <div class="min-h-screen bg-carpatina-bg flex items-center justify-center p-4">
    <div class="max-w-md w-full bg-white rounded-3xl shadow-2xl overflow-hidden border-b-8 border-carpatina-verde">
      
      <div class="bg-carpatina-verde p-8 text-center">
        <div class="inline-block bg-white p-3 rounded-2xl mb-4 shadow-inner">
          <img src="@/assets/logo.png" alt="Logo" class="h-12 w-auto">
        </div>
        <h2 class="text-white font-black text-2xl uppercase tracking-widest">
          Acces <span class="text-carpatina-portocaliu">Admin</span>
        </h2>
      </div>

      <form @submit.prevent="handleLogin" class="p-8 space-y-6">
        <div class="space-y-2">
          <label class="text-xs font-black uppercase text-carpatina-gri ml-1">Utilizator</label>
          <div class="relative">
            <User class="absolute left-3 top-3 text-gray-400" :size="20" />
            <input v-model="username" required type="text" 
                   class="w-full pl-10 p-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-carpatina-portocaliu outline-none transition">
          </div>
        </div>

        <div class="space-y-2">
          <label class="text-xs font-black uppercase text-carpatina-gri ml-1">Parolă</label>
          <div class="relative">
            <Lock class="absolute left-3 top-3 text-gray-400" :size="20" />
            <input v-model="password" required type="password" 
                   class="w-full pl-10 p-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-carpatina-portocaliu outline-none transition">
          </div>
        </div>

        <button type="submit" :disabled="loading"
                class="w-full bg-carpatina-portocaliu hover:bg-orange-600 text-white font-black py-4 rounded-xl flex items-center justify-center gap-2 shadow-lg transition transform hover:-translate-y-1 active:scale-95 disabled:opacity-50">
          <span v-if="!loading" class="flex items-center gap-2">AUTENTIFICARE <LogIn :size="20" /></span>
          <span v-else>SE ÎNCARCĂ...</span>
        </button>
      </form>

      <div class="p-4 text-center">
        <router-link to="/" class="text-xs text-gray-400 hover:text-carpatina-verde font-bold transition">
          ← ÎNAPOI ÎN SITE
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import Swal from 'sweetalert2';
import { User, Lock, LogIn } from 'lucide-vue-next';

const router = useRouter();
const username = ref('');
const password = ref('');
const loading = ref(false);

onMounted(() => {
  // --- SETĂRI SEO ȘI SECURITATE ---
  // Titlu clar pentru panoul de control
  document.title = "Autentificare Admin | Carpatina";
  
  // Instrucțiune pentru motoarele de căutare să NU indexeze această pagină
  const robotsMeta = document.querySelector('meta[name="robots"]') 
                     || document.createElement('meta');
  robotsMeta.name = "robots";
  robotsMeta.content = "noindex, nofollow";
  if (!document.querySelector('meta[name="robots"]')) {
    document.head.appendChild(robotsMeta);
  }
});

const handleLogin = async () => {
  loading.value = true;
  const formData = new FormData();
  formData.append('username', username.value);
  formData.append('password', password.value);

  try {
    const res = await axios.post('/admin/login', formData);
    
    if (res.data.status === 'success') {
      localStorage.setItem('carpatina_admin', res.data.username);
      
      Swal.fire({
        title: 'Salut, Briciule!',
        text: 'Te-ai logat cu succes.',
        icon: 'success',
        timer: 1500,
        showConfirmButton: false
      });

      router.push('/admin');
    } else {
      Swal.fire('Eroare', res.data.message, 'error');
    }
  } catch (err) {
    Swal.fire('Eroare', 'Serverul nu răspunde. Verifică FastAPI!', 'error');
  } finally {
    loading.value = false;
  }
};
</script>